import Vue from 'vue';
import { clone } from 'lodash';
import { BfModal, BfDialog, BfButton } from 'src/components/Butterfly';
import { ALLOWED_TYPES } from "components/widgets/UniqueIdFieldsModal/UniqueIdUtils";
export default Vue.extend({
    components: {
        BfModal, BfDialog, BfButton,
    },
    props: {
        visible: { type: Boolean, default: false },
        schema: { type: Array, required: true },
        currentFields: { type: Array, required: true },
    },
    data() {
        return {
            selected: [],
        };
    },
    computed: {
        options() {
            return this.schema.map((col) => {
                const isDisabled = !ALLOWED_TYPES.includes(col.type);
                const description = isDisabled ? '(' + col.typename + ' cannot be selected.)' : '';
                return {
                    disabled: isDisabled,
                    name: col.name,
                    description: description,
                };
            });
        },
    },
    watch: {
        currentFields() {
            this.resetState();
        }
    },
    methods: {
        resetState() {
            this.selected = this.currentFields;
        },
        close() {
            this.resetState();
            this.$emit('close');
        },
        done() {
            this.$emit('values-changed', clone(this.selected));
            this.close();
        },
    }
});
